import { Injectable } from '@angular/core';

@Injectable()

export class Globals {
    //QA
    //APIURL: string = 'https://odaklaqa.odaksolutions.in/api';
    //APISAURL: string = 'https://odaksaqa.odaksolutions.in/api';
    //APIURLFF: string = 'https://odaksaqa.odaksolutions.in/ffddev/api';
    //APIFNURL: string = 'https://odakfnqa.odaksolutions.in/api';


    //UAT

    //APIURLLA: string = 'https://odaklauat.odaksolutions.in/api';
    //APISAURL: string = 'https://odaksauat.odaksolutions.in/api';
    //APIURLFF: string = 'https://odaksauat.odaksolutions.in/ffddev/api';
    //APIFNURL: string = 'https://odakfnuat.odaksolutions.in/api';

    //APIURL: string = 'https://localhost:44323/api';
    //APIURLFF: string = 'https://localhost:44345/api';

    APIURL: string = 'https://navioindia.freighteiz.com/api';
    //APIURL: string = 'https://skib.freighteiz.com/api';
    //APIURL: string = 'https://nikins.freighteiz.com/api';
    //APIURL: string = 'https://naviouat.freighteiz.com/api';
    //APIURL: string = 'https://odakuat.odaksolutions.in/api';

    //Freighteiz
    APIURLLA: string = 'https://la-navioindia.freighteiz.com/api';
    APISAURL: string = 'https://sa-navioindia.freighteiz.com/api';
    APIURLFF: string = 'https://sa-navioindia.freighteiz.com/ffddev/api';
    APIFNURL: string = 'https://fn-navioindia.freighteiz.com/api';


    //skib

    //APIURLLA: string = 'https://la-skib.freighteiz.com/api';
    //APISAURL: string = 'https://sa-skib.freighteiz.com/api';
    //APIURLFF: string = 'https://sa-skib.freighteiz.com/ffddev/api';
    //APIFNURL: string = 'https://fn-skib.freighteiz.com/api';


    //nikins
    //APIURLLA: string = 'https://la-nikins.freighteiz.com/api';
    //APISAURL: string = 'https://sa-nikins.freighteiz.com/api';
    //APIURLFF: string = 'https://sa-nikins.freighteiz.com/ffddev/api';
    //APIFNURL: string = 'https://fn-nikins.freighteiz.com/api';


    //NavioUAT
    //APIURLLA: string = 'https://la-naviouat.freighteiz.com/api';
    //APISAURL: string = 'https://sa-naviouat.freighteiz.com/api';
    //APIURLFF: string = 'https://sa-naviouat.freighteiz.com/ffddev/api';
    //APIFNURL: string = 'https://fn-naviouat.freighteiz.com/api';

}







